import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100 mt-3 d-flex"
}
const _hoisted_2 = { class: "p-float-label hiding" }
const _hoisted_3 = { class: "p-floating-label" }
const _hoisted_4 = {
  class: "p-inputgroup position-relative",
  id: "parent"
}
const _hoisted_5 = {
  key: 0,
  class: "position-absolute w-100 top-100 bg-white border",
  style: {"z-index":"100"}
}
const _hoisted_6 = { class: "grid-symbol-search p-inputgroup" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "text-center pt-3"
}
const _hoisted_9 = { class: "symbol-grid" }
const _hoisted_10 = ["onMousedown"]
const _hoisted_11 = { class: "p-inputgroup-addon p-0" }
const _hoisted_12 = {
  class: "p-inputgroup-addon p-0 position-relative",
  style: {"width":"30px"}
}
const _hoisted_13 = {
  key: 0,
  class: "position-absolute top-0 end-0",
  style: {"z-index":"10"}
}
const _hoisted_14 = { class: "p-inputgroup-addon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_CustomColorPicker = _resolveComponent("CustomColorPicker")!

  return (_ctx.currIcon)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t( 'editor.icon' )), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.showSuggestions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.symbolSearch,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.symbolSearch) = $event)),
                    type: "text",
                    class: "w-auto",
                    onInput: _ctx.filterSuggestions,
                    onBlur: _ctx.hideSuggestions
                  }, null, 8, ["modelValue", "onInput", "onBlur"]),
                  _hoisted_7
                ]),
                (_ctx.filteredSuggestions.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t( 'common.noElements' )), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSuggestions, (image) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "grid-symbol",
                      tabindex: "-1",
                      onMousedown: ($event: any) => (_ctx.changeIcon(image))
                    }, [
                      _createVNode(_component_Icon, {
                        icon: {name: image, source: _ctx.currSource.code}
                      }, null, 8, ["icon"])
                    ], 40, _hoisted_10))
                  }), 256))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.currSource,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currSource) = $event)),
              options: _ctx.iconSources,
              placeholder: _ctx.$t('common.select')
            }, {
              option: _withCtx((slotProps) => [
                _createVNode(_component_Icon, {
                  icon: slotProps.option.icon
                }, null, 8, ["icon"])
              ]),
              value: _withCtx((slotProps) => [
                _createVNode(_component_Icon, {
                  icon: slotProps.value.icon
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "placeholder"])
          ]),
          _createVNode(_component_InputText, {
            type: "text",
            class: "w-auto",
            modelValue: _ctx.currIcon.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currIcon.name) = $event)),
            onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSuggestions = true)),
            onBlur: _ctx.hideSuggestions
          }, null, 8, ["modelValue", "onBlur"]),
          _createElementVNode("span", _hoisted_12, [
            (_ctx.currIcon.color)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("i", {
                    class: "bi bi-x text-black bg-white d-flex rounded-circle cursor-pointer",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.currIcon.color = null), ["stop"]))
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_CustomColorPicker, {
              value: _ctx.currIcon.color,
              onUpdate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currIcon.color = $event))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_component_Icon, { icon: _ctx.currIcon }, null, 8, ["icon"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}